import { CustomFileReader } from './intefaces/file-reader';

export class FormFileInput {
  private data: ArrayBuffer | string = new ArrayBuffer(0);

  constructor(private readonly file: File, private readonly filename: string) {}

  setData(data: ArrayBuffer | string): void {
    this.data = data;
  }
  getData(): ArrayBuffer | string {
    return this.data;
  }

  getInputName(): string {
    return this.filename.split('.')[0];
  }

  getBlob(): Blob {
    return new Blob([new Uint8Array(this.getData() as ArrayBuffer)]);
  }

  getBase64(reader: CustomFileReader): Promise<string> {
    return reader.readFileAsBase64String(this.file);
  }

  read(reader: CustomFileReader): Promise<void> {
    return reader
      .readFileAsArrayBuffer(this.file)
      .then((result: ProgressEvent<FileReader>) => {
        this.data = result.target?.result as ArrayBuffer;
      });
  }

  readAsBase64(reader: CustomFileReader): Promise<void> {
    return reader.readFileAsBase64String(this.file).then((result: string) => {
      this.data = result;
    });
  }
}
